const OfficeSection = () => {
  return (
    <section id="office" className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">

        {/* セクションヘッダー */}
        <div className="flex items-start gap-4 md:gap-6 mb-10 md:mb-16">
          <div className="flex-shrink-0 pt-1">
            <div className="w-px h-12 md:h-16 bg-[#1a3a5c]"></div>
          </div>
          <div>
            <p className="text-[#1a3a5c] text-xs tracking-[0.3em] font-medium uppercase mb-2">Office Information</p>
            <h2
              className="text-3xl md:text-4xl font-bold text-slate-800 mb-3"
              style={{ fontFamily: "'Noto Serif JP', serif" }}
            >
              事務所概要
            </h2>
            <p className="text-slate-500 text-sm">行政書士ＭＫ法務事務所</p>
          </div>
        </div>

        {/* 事務所写真＋情報 */}
        <div className="grid lg:grid-cols-2 gap-8 md:gap-12 mb-10 md:mb-12">

          {/* 左：事務所情報 */}
          <div>
            <div className="w-full h-[220px] md:h-[300px] overflow-hidden mb-6 md:mb-8">
              <img
                src="https://public.readdy.ai/ai/img_res/edited_a69a88ead56ad6fe09d7a48baf6a9095_04951b79.jpg"
                alt="代表 梶川雅弘"
                className="w-full h-full object-cover object-center"
              />
            </div>

            <div className="space-y-4 md:space-y-5">
              {[
                { icon: 'ri-home-line', label: '事務所名', value: '行政書士ＭＫ法務事務所' },
                { icon: 'ri-map-pin-line', label: '所在地', value: '〒561-0802\n大阪府豊中市曽根西町1-9-28\nＲＳビルディング4F' },
                { icon: 'ri-user-line', label: '代表者', value: '行政書士　梶川雅弘' },
                { icon: 'ri-shield-check-line', label: '登録番号', value: '第24260685号' },
                { icon: 'ri-award-line', label: '資格', value: '出入国在留管理庁届出申請取次行政書士' },
              ].map((item, i) => (
                <div key={i} className="flex items-start gap-3 md:gap-4 pb-4 md:pb-5 border-b border-slate-100 last:border-0">
                  <div className="w-7 h-7 md:w-8 md:h-8 flex items-center justify-center bg-slate-100 flex-shrink-0 mt-0.5">
                    <i className={`${item.icon} text-[#1a3a5c] text-xs md:text-sm`}></i>
                  </div>
                  <div>
                    <p className="text-slate-400 text-xs tracking-wider mb-0.5">{item.label}</p>
                    <p className="font-bold text-slate-800 text-sm whitespace-pre-line">{item.value}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* 右：営業時間・アクセス */}
          <div>
            {/* 営業時間 */}
            <div className="bg-[#1a3a5c] p-6 md:p-8 mb-5 md:mb-6">
              <p className="text-blue-300 text-xs tracking-[0.3em] uppercase mb-4">Business Hours</p>
              <div className="flex items-center gap-3 mb-3">
                <i className="ri-calendar-check-line text-blue-300 text-xl md:text-2xl"></i>
                <p className="text-white font-bold text-lg md:text-xl" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                  年中無休（不定休）
                </p>
              </div>
              <p className="text-white/80 text-xl md:text-2xl font-bold tracking-wide">
                午前9時 〜 深夜24時
              </p>
              <p className="text-white/50 text-xs mt-3">
                ※不定休のため、事前にお電話でご確認いただくことをお勧めします
              </p>
            </div>

            {/* 電話・アクセス */}
            <div className="border border-slate-200 p-6 md:p-8 mb-5 md:mb-6">
              <p className="text-slate-400 text-xs tracking-[0.3em] uppercase mb-4 md:mb-5">Contact &amp; Access</p>
              <div className="space-y-4 md:space-y-5">
                <div className="flex items-start gap-3 md:gap-4">
                  <div className="w-7 h-7 md:w-8 md:h-8 flex items-center justify-center bg-slate-100 flex-shrink-0">
                    <i className="ri-phone-fill text-[#1a3a5c] text-xs md:text-sm"></i>
                  </div>
                  <div className="space-y-2">
                    <div>
                      <p className="text-slate-400 text-xs mb-0.5">代表電話</p>
                      <a href="tel:06-7777-3813" className="text-xl md:text-2xl font-bold text-slate-800 hover:text-[#1a3a5c] transition-colors cursor-pointer tracking-wider">
                        06-7777-3813
                      </a>
                    </div>
                    <div>
                      <p className="text-slate-400 text-xs mb-0.5">代表直通</p>
                      <a href="tel:070-9096-1669" className="text-xl md:text-2xl font-bold text-slate-800 hover:text-[#1a3a5c] transition-colors cursor-pointer tracking-wider">
                        070-9096-1669
                      </a>
                    </div>
                  </div>
                </div>
                <div className="flex items-start gap-3 md:gap-4">
                  <div className="w-7 h-7 md:w-8 md:h-8 flex items-center justify-center bg-slate-100 flex-shrink-0">
                    <i className="ri-train-line text-[#1a3a5c] text-xs md:text-sm"></i>
                  </div>
                  <div>
                    <p className="text-slate-400 text-xs mb-1">最寄り駅</p>
                    <p className="font-bold text-slate-800 text-sm leading-relaxed">
                      阪急宝塚線「曽根駅」徒歩5分<br />
                      大阪メトロ御堂筋線「緑地公園駅」車で10分
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* 代表者写真エリア */}
            <div className="flex items-center gap-4 md:gap-5 bg-slate-50 border border-slate-200 p-4 md:p-5">
              <div className="w-16 h-16 md:w-20 md:h-20 overflow-hidden flex-shrink-0">
                <img
                  src="https://public.readdy.ai/ai/img_res/edited_da310668e815e2c294ac2a7a1f11294b_bc5a3928.jpg"
                  alt="代表 梶川雅弘"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div>
                <p className="text-slate-400 text-xs tracking-wider mb-1">代表行政書士</p>
                <p className="text-slate-800 font-bold text-base md:text-lg" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                  梶川 雅弘
                </p>
                <p className="text-slate-500 text-xs mt-1">出入国在留管理庁届出申請取次行政書士</p>
              </div>
            </div>
          </div>
        </div>

        {/* 地図 */}
        <div className="border border-slate-200 overflow-hidden">
          <div className="bg-slate-50 border-b border-slate-200 px-4 md:px-6 py-3 flex items-center gap-2">
            <i className="ri-map-pin-line text-[#1a3a5c] text-sm"></i>
            <span className="text-slate-600 text-xs font-medium tracking-wider">大阪府豊中市曽根西町1-9-28 ＲＳビルディング4F</span>
          </div>
          <div className="w-full h-64 md:h-80">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3277.478209928789!2d135.46571857440168!3d34.76873477956163!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6000e5482ea42c41%3A0x6cc4898b4676dee9!2z44CSNTYxLTA4MDEg5aSn6Ziq5bqc6LGK5Lit5biC5pu95qC56KW_55S677yR5LiB55uu77yZ4oiS77yS77yYIO-8su-8s-ODk-ODqw!5e0!3m2!1sja!2sjp!4v1767593122923!5m2!1sja!2sjp"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="事務所所在地"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OfficeSection;
